import React, { useEffect } from 'react'
import { styled } from '../../stitches.config';
import { inject, observer } from 'mobx-react'
import { observable, action } from 'mobx'

import Link from '../Link'
import Header from './Header'
import Content from "./Content"
import SeeAlsoArticles from "./Components/SeeAlsoArticles";
import { ArticleWrapper, ArticleRow, ArticleColumn } from '../../pages/Article'
import { ArticleRightColumn } from './ArticleRightColumn'
import Adslot from '../Adslot'
import Parts from './Parts/Parts'
import LinkChanger from './LinkChanger.js'
import { withlazyload } from "../HOCs/WithLazyLoad"

@withlazyload({
    once: true,
    offset: 700
})
@inject('ArticleStore', 'UIStore')
@observer
export default class DynamicNextArticle extends React.Component {
    @observable post = {}
    @observable isFetching = true;

    @action
    fetchArticle = (fetchUrl = `${window.API_HOST}/pwa-article/${this.props.id}`) => {
        fetch(fetchUrl)
            .then(res => {
                // console.log('fetching...', this.props.id)
                return res.ok
                    ? res.json()
                    : Promise.reject(res.status);
            })
            .then(action('fetching article', res => {
                const BodyPart = res.article.BodyPart.filter(block => !["adslot", "link_changer"].includes(block.type)).slice(0, 5)
                this.post = {
                    ...res,
                    article: {
                        ...res.article,
                        BodyPart
                    }
                };
                this.isFetching = false;
            }))
    }

    componentDidMount() {
        this.fetchArticle();
    }

    render() {
        const { article, DATA_LAYER, topics = [] } = this.post;
        const showColumn = window.innerWidth >= 1310;
        return (
            <div>
                {this.isFetching ? <div style={{ height: 300 }} /> : <LinkChanger
                    partialVisibility={true}
                    minTopValue={500}
                    url={this.post.article?.url}
                    data={{
                        'event': 'virtualPageview',
                        'virtualPageURL': article.uri,
                        'virtualPageTitle': article.seo_title,
                        'pageType': 'Artykuł doładowany',
                        'articleSection': article.category.name,
                        'articleTag': topics.length > 0 ? topics[0].name : "",
                        'articleAuthor': DATA_LAYER.articleAuthor,
                        'articleCharacterRange': DATA_LAYER.articleCharacterRange
                    }}>
                    <Wrap className="container">
                        <Header article={article} hideAdslots />
                        <ArticleRow className="row">
                            <ArticleColumn className="col-lg-8">
                                <div className={"article-body article-body--" + article.category.type}>
                                    <div className="art">
                                        <Parts article={article} parts={article.BodyPart} hideAdslots />
                                    </div>
                                </div>
                                {/* <Content article={this.post.article} hideAdslots /> */}
                            </ArticleColumn>
                            {showColumn && <ArticleColumn className="col-lg-4">
                                <ArticleRightColumn>
                                    <SeeAlsoArticles similarArticles={this.post.similar_articles} />
                                </ArticleRightColumn>
                            </ArticleColumn>}
                        </ArticleRow>
                        <Overlay>
                            <StyledLink to={article.url}><span>Czytaj dalej</span></StyledLink>
                        </Overlay>
                    </Wrap>
                </LinkChanger>}
                <Adslot name={`ART_Billboard_${this.props.adslotNum}`} />
            </div>
        )
    }
}

const Overlay = styled("div", {
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    height: "300px",
    backgroundColor: "rgb(255,255,255)",
    backgroundImage: "linear-gradient(0deg, rgba(255,255,255,1) 40%, rgba(255,255,255,0) 100%)",
    zIndex: 5
});

const Wrap = styled("div", {
    position: "relative",
    maxHeight: "1150px",
    overflow: "hidden"
});

const StyledLink = styled(Link, {
    position: "absolute",
    width: "230px",
    bottom: "50px",
    margin: "20px auto",
    left: "0",
    right: "0",
    textAlign: "center",
    display: "block",
    textTransform: "uppercase",
    padding: "12px 20px",
    backgroundColor: "#fff",
    color: "#222222",
    border: "2px solid #272424",
    borderRadius: "6px",
    cursor: "pointer",
    "&:before": {
        content: "",
        display: "block",
        width: "40px",
        height: "25px",
        backgroundColor: "#fff",
        position: "absolute",
        top: "-4px",
        right: "-4px"
    },
    "&:after": {
        content: "",
        display: "block",
        width: "40px",
        height: "25px",
        backgroundColor: "#fff",
        position: "absolute",
        bottom: "-4px",
        left: "-4px"
    },
    "&:hover, &:visited, &:focus": {
        textDecoration: "none",
        color: "#222"
    }
});